export default {"src":"/_next/static/media/topCurved_bg_4k.4e3d9c34.svg","height":2110,"width":3840};